<template>
<div>
  <div class="padding-top20" v-if="isShow">
    <div class="color-red bold font-size1 text-align-center flex-align-justify"><span class=" margin-right12 bgcolor-red border-radius100 color-white block flex-align-justify" style="width:26px;height:26px;"><van-icon name="fail" /></span>注销账号是不可恢复的操作</div>
    <div class="color-666 font-size-2 paddingX20  padding-top20 line-height25">请确认与您账号相关产生的所有数据是否都妥善处理。注销账号申请前，将会进行身份验证，验证后可提交注销申请。</div>
    <div  class="color-red font-size-2 paddingX20  padding-bottom20 ">
        请注意：注销本应用账号，您将无法使用原有账号密码登陆、查看和找回此账号下的任何数据，包括但不限于以下内容：<br>
        1、账号绑定的个人信息；<br>
        2、曾绑定过的所有就诊人信息或健康档案信息；<br>
        3、账号下所有就诊人参与的业务模块记录信息；<br>
        4、将不会接收到业务的任何短信通知；<br>
    </div>
    <div class="padding-top12 bgcolor-f6"></div>
    <div v-if="phone" class="paddingX20 padding-top18">
        <div class="font-size2 bold color-333">身份验证</div>
        <div class="font-size-3 color-333 margin-top8">当前账号为：<span class="color-theme-text">{{account}}</span></div>
    </div>
    <section v-else>
        <div class="font-size-3 color-666 margin-top8 paddingX20 line-height25">
                系统未识别到您的身份验证信息，为方便客服人员与您本人沟通确认账号注销事宜，请继续以下操作：
        </div>
        <div class="marginX20 border-bottom1">
            <van-field type="number" :value="tel" :maxlength="11"  :border="false"  placeholder="请输入手机号" class="width100" @input="input('tel', $event)" clearable></van-field>
        </div>
    </section>
    <section class="paddingX20 flex-align margin-top20">
        <div class="flex-align border-bottom1 width100 ">
            <van-field type="number" :value="code"  :border="false" placeholder="请输入验证码" class="width100" @input="input('code', $event)" :use-button-slot="true" clearable></van-field>
        </div>
        <div class="itemflex-00auto margin-left10">
            <van-button v-if="!timer" slot="button" type="info" size="small" plain  @click="getCode">获取验证码</van-button>
            <van-button v-else slot="button" type="primary" size="small"  plain color="#cdcdcd">{{timeCount}}s </van-button>
        </div>
    </section>
    <section class="margin-top100 paddingX40 font-size6 clear-both margin-bottom20">
       <van-button type="info"  :disabled="!ableSubmit" :class="['btn-theme margin-top20 width100 ',ableSubmit? 'btn-theme' : 'btn-theme-disabled']" @click="submit">提交注销申请</van-button>
      </section>
      <identify ref="identify" :mobile="tel" ></identify>
  </div>
  </div>
</template>
<script>
import identify from '@/components/identify_code'
import { CODE_TIMER } from '@/mixin'
export default {
  mixins: [CODE_TIMER],
  components: { identify },
  data () {
    return {
      code: '',
      gray: true, // 置灰,
      loginFlag: '',
      account:'',
      phone:'',
      tel:'',
      isShow:false,
      result:''
    }
  },
  computed: {
    ableSubmit () {
        console.log('变化')
        return this.tel && this.code && this.gray
    }
  },
  mounted(){
     
      this.cancellationDecrypt()
  },
  methods: {
    async cancellationDecrypt(){
      
        this.$post({
            url:this.$apis.cancellationDecrypt,
            param:{
                content:decodeURI(this.$route.query.content),
                tokenId:this.$route.query.tokenId,
            }
        }).then(res =>{
            if(res.code==0){
                let data = res.data
                this.result = data
                this.cancellationCheck(data.appId,data.userId)
                this.gray = true
                this.tel= data.phone
                this.phone= data.phone
                this.account = data.phone.replace(/(\d{3})(.*)(\d{4})/, function (str, $s1, $s2, $s3) {
                  return $s1 + '*****' + $s3
                })
            }else{
                this.gray = true
                this.$toast(res.message);
            }
        }).catch(() =>{
            this.gray = true
        })
    },
    cancellationCheck(appId,userId){
         this.$post({
            url:this.$apis.cancellationCheck,
            param:{
               appId:appId||'',
               userId:userId||''
            }
        }).then(res =>{
            if(res.code==0){
                if(res.data){
                    this.$router.replace({path:'/cancellationResult'})
                }else{
                    this.isShow=true
                }
            }
        })
    },
    vertify () {
      if (!this.$validate.isMobile(this.tel)) {
         this.$toast('手机号码格式错误');
        return false
      }
      return true
    },
    submit () {
      if (!this.vertify()) {
        return false
      }
      this.gray = false
      this.$post({
          isLoading: true,
          url:this.$apis.cancellationSubmit,
          param:{
              appId:this.result.appId||'',
              appName:this.result.appName||'',
              userId:this.result.userId||'',
              userName:this.result.userName||'',
              phone:this.tel||'',
              code:this.code||''
          }
      }).then(res =>{
          if(res.code==0){
               this.$router.replace({path:'/cancellationResult'})
               this.gray = true
                // window.location.href=window.location.origin+"/#/cancellationResult"
          }else{
              this.$toast(res.message)
              this.gray = true
          }
      })
    },
    input (key, event) {
      this[key] = event
    }
    
  }
}
</script>
<style lang="scss">
.van-popup{
    border-radius: 16rpx !important;
}
.login {
    .left-button {
      margin-right: 6%;
    }
    .width47 {
      width: 47%;
    }
    .van-field__input{
        min-height:25px;
    }
  }
</style>
<style lang="scss" scoped>
.img-logo {
    // margin: 66rpx 0 90rpx 300rpx;
    display: block;
    width: 216rpx;
    // height: 146rpx;
}
.photo-doctor {
    margin-top: 58rpx;
    width: 136rpx;
    height: 136rpx;
}
.label {
    width: 140rpx;
    font-size: 32rpx;
    color: #999999;
}
.bottom-btn {
    padding: 18rpx 36rpx;
    border-radius: 100rpx;
    border: #1db04e 2rpx solid;
    color: #333333;
}
.van-cell{
    padding-left:0px;
}
</style>

